import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getPoList({ commit, state }, { params }) {
    return axios
      .get(`/v1/po/`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList.length > 0) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getCategoryList({ commit, state }, { params }) {
    return axios
      .get(`/v1/category/`, {
        params: params,
      })
      .then(response => {
        const categoryList = response.data.docs
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (categoryList.length > 0) {
          return categoryList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getSubCategoryList({ commit, state }, { params }) {
    return axios
      .get(`/v1/subcategory/`, {
        params: params,
      })
      .then(response => {
        const subCategoryList = response.data.docs
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (subCategoryList.length > 0) {
          return subCategoryList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getItemList({ commit, state }) {
    return axios
      .get(`/v1/inventoryitem/`)
      .then(response => {
        const itemList = response.data.docs
        if (itemList.length > 0) {
          return itemList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllIssueNoteList({ commit, state }, { params }) {
    return axios
      .get(`/v1/issuenote/getAllIssueNoteList/`, {
        params: params,
      })
      .then(response => {
        const issueNoteCount = response.data
        return issueNoteCount
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierList({ commit, state }, { params }) {
    return axios
      .get(`/v1/supplier/`, {
        params: params,
      })
      .then(response => {
        const supplierList = response.data.docs
        if (supplierList.length > 0) {
          return supplierList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getRestaurantList({ commit, state }) {
    return axios
      .get(`/v1/restaurant/`)
      .then(response => {
        const restaurantList = response.data.docs
        if (restaurantList.length > 0) {
          return restaurantList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getTaxCombinationList({ commit, state }, { params }) {
    return axios
      .get(`/v1/taxcombination/`, {
        params: params,
      })
      .then(response => {
        const taxCombinationList = response.data.docs
        if (taxCombinationList.length > 0) {
          return taxCombinationList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getPaymentModeList({ commit, state }, { params }) {
    return axios
      .get(`/v1/paymentmode/`, {
        params: params,
      })
      .then(response => {
        const paymentModeList = response.data.docs
        if (paymentModeList.length > 0) {
          return paymentModeList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertPo({ commit, state }, { poObject }) {
    return axios
      .post(`v1/po/insertPO`, poObject, {
        timeout: 30000,
      })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet: poObject.outletId,
          service: 'createNewPO.vue',
          function: 'insertPo',
          time: poObject.modifiedDatetime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the poList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the PO is being saved.',
          }
        })
      })
  },
  updatePo({ commit, state }, { poObject }) {
    return axios
      .post(`v1/po/updatePO`, poObject, {
        timeout: 30000,
      })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet: poObject.outletId + ' - ' + poObject.pONumber,
          service: 'updatePO.vue',
          function: 'updatePo',
          time: poObject.modifiedDatetime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the poList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the PO is being updated.',
          }
        })
      })
  },
  approvePo({ commit, state }, { poObject }) {
    return axios
      .post(`v1/po/approvePO`, poObject, { timeout: 30000 })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet: poObject.outletId + ' - ' + poObject.pONumber,
          service: 'summary.vue',
          function: 'approvePo',
          time: poObject.approvedDateTime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the poList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the PO is being Approved.',
          }
        })
      })
  },
  getPoCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/po/getPoCount/`, {
        params: params,
      })
      .then(response => {
        const purchaseOrderCount = response.data
        return purchaseOrderCount
      })
      .catch(err => {
        throw err
      })
  },
  getAllPOList({ commit, state }, { params }) {
    return axios
      .get(`/v1/po/getAllPOList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  getGrnList({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertGrn({ commit, state }, { grnObject }) {
    return axios
      .post(`v1/grn/`, grnObject, { timeout: 30000 })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        return {
          ok: false,
          alert:
            'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page.',
        }
      })
  },
  insertNewGrn({ commit, state }, { grnObject }) {
    return axios
      .post(`v1/grn/insertGRN`, grnObject, { timeout: 30000 })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet:
            grnObject.outletId +
            ' & invoice Number - ' +
            grnObject.invoiceNumber,
          service: 'createNewGRN.vue',
          function: 'insertGRN',
          time: grnObject.addedDatetime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the grnList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the GRN is being saved.',
          }
        })
      })
  },
  updateGrn({ commit, state }, { grnObject }) {
    return axios
      .post(`v1/grn/updateGRN`, grnObject, { timeout: 30000 })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet: grnObject.outletId + ' - ' + grnObject.grnNumber,
          service: 'updateGRN.vue',
          function: 'updateGrn',
          time: grnObject.modifiedDatetime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the grnList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the GRN is being updated.',
          }
        })
      })
  },
  approveGrn({ commit, state }, { grnObject }) {
    return axios
      .post(`v1/grn/approveGRN`, grnObject, { timeout: 30000 })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        let data = {
          outlet: grnObject.outletId + ' - ' + grnObject.grnNumber,
          service: 'grnSummary.vue',
          function: 'approveGrn',
          time: grnObject.approvedDateTime,
          error:
            'Page did not receive the response in under 30s so the page redirected to the grnList page',
        }
        return axios.post(`v1/emailTrigger`, data).then(response => {
          return {
            ok: false,
            alert:
              'This Page Did Not Respond In A Timely Manner. You Will be Now Redirected To The Main Page. Please wait while the GRN is being Approved.',
          }
        })
      })
  },
  getGrnByUUId({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/grnById/`, {
        params: params,
      })
      .then(response => {
        const grnCount = response.data
        return grnCount
      })
      .catch(err => {
        throw err
      })
  },
  getGrnCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/getGrnCount/`, {
        params: params,
      })
      .then(response => {
        const grnCount = response.data
        return grnCount
      })
      .catch(err => {
        throw err
      })
  },
  getAllGrnList({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/getAllGrnList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  getGrnById({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/getGrn/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  getStockAdjustmentList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockadjustment/`, {
        params: params,
      })
      .then(response => {
        const stockAdjustmentList = response.data
        if (stockAdjustmentList.length > 0) {
          return stockAdjustmentList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertStockAdjustment({ commit, state }, { stockAdjustmentObject }) {
    return axios
      .post(`v1/stockadjustment/`, stockAdjustmentObject)
      .then(response => {
        return response.data
      })
  },
  getStockAdjustmentCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockadjustment/getStockAdjustmentCount/`, {
        params: params,
      })
      .then(response => {
        const stockAdjustmentCount = response.data
        return stockAdjustmentCount
      })
      .catch(err => {
        throw err
      })
  },
  getAdjustmentTypeList({ commit, state }, { params }) {
    return axios
      .get(`/v1/adjustmenttype/`, {
        params: params,
      })
      .then(response => {
        const adjustmentTypeList = response.data.docs
        if (adjustmentTypeList.length > 0) {
          return adjustmentTypeList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertNewStockAdjustment({ commit, state }, { stockAdjustmentObject }) {
    return axios
      .post(`v1/stockadjustment/insertSA`, stockAdjustmentObject)
      .then(response => {
        return response.data
      })
  },
  updateNewStockAdjustment({ commit, state }, { stockAdjustmentObject }) {
    return axios
      .post(`v1/stockadjustment/updateSA`, stockAdjustmentObject)
      .then(response => {
        return response.data
      })
  },
  approveNewStockAdjustment({ commit, state }, { stockAdjustmentObject }) {
    return axios
      .post(`v1/stockadjustment/approveSA`, stockAdjustmentObject)
      .then(response => {
        return response.data
      })
  },
  getAllStockAdjustmentList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockadjustment/getAllStockAdjustmentList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  getStockEntryList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockentry/`, {
        params: params,
      })
      .then(response => {
        const stockEntryList = response.data
        if (stockEntryList.length > 0) {
          return stockEntryList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertStockEntry({ commit, state }, { stockEntryObject }) {
    return axios.post(`v1/stockentry/`, stockEntryObject).then(response => {
      return response.data
    })
  },
  insertNewStockEntry({ commit, state }, { stockEntryObject }) {
    return axios
      .post(`v1/stockentry/insertSE`, stockEntryObject)
      .then(response => {
        return response.data
      })
  },
  updateNewStockEntry({ commit, state }, { stockEntryObject }) {
    return axios
      .post(`v1/stockentry/updateSE`, stockEntryObject)
      .then(response => {
        return response.data
      })
  },
  approveStockEntry({ commit, state }, { stockEntryObject }) {
    return axios
      .post(`v1/stockentry/approveSE`, stockEntryObject)
      .then(response => {
        return response.data
      })
  },
  getStockEntryCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockentry/getStockEntryCount/`, {
        params: params,
      })
      .then(response => {
        const stockEntryCount = response.data
        return stockEntryCount
      })
      .catch(err => {
        throw err
      })
  },
  getAllStockEntryList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockentry/getAllStockEntryList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  getWastageNoteList({ commit, state }, { params }) {
    return axios
      .get(`/v1/wastagemanagement/`, {
        params: params,
      })
      .then(response => {
        const wastageNoteList = response.data
        if (wastageNoteList.length > 0) {
          return wastageNoteList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertWastageNote({ commit, state }, { wastageManagementObject }) {
    return axios
      .post(`v1/wastagemanagement/`, wastageManagementObject)
      .then(response => {
        return response.data
      })
  },
  insertNewWastageNote({ commit, state }, { wastageManagementObject }) {
    return axios
      .post(`v1/wastagemanagement/insertWS`, wastageManagementObject)
      .then(response => {
        return response.data
      })
  },
  updateNewWastageNote({ commit, state }, { wastageManagementObject }) {
    return axios
      .post(`v1/wastagemanagement/updateWS`, wastageManagementObject)
      .then(response => {
        return response.data
      })
  },
  approveWastageNote({ commit, state }, { wastageManagementObject }) {
    return axios
      .post(`v1/wastagemanagement/approveWS`, wastageManagementObject)
      .then(response => {
        return response.data
      })
  },
  getWastageManagementCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/wastagemanagement/getWastageManagementCount/`, {
        params: params,
      })
      .then(response => {
        const wastageCount = response.data
        return wastageCount
      })
      .catch(err => {
        throw err
      })
  },
  getAllWastageList({ commit, state }, { params }) {
    return axios
      .get(`/v1/wastagemanagement/getAllWastageList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },

  getMeasureTypeList({ commit, state }, { params }) {
    return axios
      .get(`/v1/uom/`, {
        params: params,
      })
      .then(response => {
        const measureTypeList = response.data.docs
        if (measureTypeList.length > 0) {
          return measureTypeList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertMeasureType({ commit, state }, { measureTypeObject }) {
    return axios
      .post(`v1/uom/`, measureTypeObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  getUnitList({ commit, state }, { params }) {
    return axios
      .get(`/v1/uom/getUnit`, {
        params: params,
      })
      .then(response => {
        const unitList = response.data.docs
        if (unitList.length > 0) {
          return unitList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertUnit({ commit, state }, { unitObject }) {
    return axios.post(`v1/uom/insertUnit`, unitObject).then(response => {
      return response.data
    })
  },
  copyUOM({ commit, state }, { unitObject }) {
    console.log(unitObject, 'unit obj')
    return axios.post(`v1/uom/copyUOM`, unitObject).then(response => {
      return response.data
    })
  },
  getPriorityLevelList({ commit, state }, { params }) {
    return axios
      .get(`/v1/prioritylevel/`, {
        params: params,
      })
      .then(response => {
        const priorityLevelList = response.data.docs
        if (priorityLevelList.length > 0) {
          return priorityLevelList[0]
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertInventoryItem({ commit, state }, { itemObject }) {
    return axios
      .post(`v1/inventoryitemmanagement/`, itemObject)
      .then(response => {
        return response.data
      })
  },
  copyInvItems({ commit, state }, { params }) {
    return axios
      .post(`v1/inventoryitemmanagement/copyInvItems`, params)
      .then(response => {
        return response.data
      })
  },
  getInventoryItemList({ commit, state }, { params }) {
    return axios
      .get(`/v1/inventoryitemmanagement/`, {
        params: params,
      })
      .then(response => {
        const inventoryItemList = response.data
        if (inventoryItemList.length > 0) {
          return inventoryItemList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllInventoryItemList({ commit, state }, { params }) {
    return axios
      .get(`/v1/inventoryitemmanagement/getAllwithDeleted`, {
        params: params,
      })
      .then(response => {
        const inventoryItemList = response.data
        if (inventoryItemList.length > 0) {
          return inventoryItemList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getInvItemIngredeants({ commit, state }, { params }) {
    return axios
      .get(`/v1/inventoryitemmanagement/batchProcess`, {
        params: params,
      })
      .then(response => {
        const inventoryItemList = response.data
        if (inventoryItemList.length > 0) {
          return inventoryItemList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAvailableWastageStock({ commit, state }, { params }) {
    return axios
      .get(`/v1/wastagemanagement/getAvailableWastageStock/`, {
        params: params,
      })
      .then(response => {
        const wastageStock = response.data
        return wastageStock
      })
      .catch(err => {
        throw err
      })
  },
  getInventoryItemCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/inventoryitemmanagement/getInventoryItemCount/`, {
        params: params,
      })
      .then(response => {
        const inventoryItemCount = response.data
        return inventoryItemCount
      })
      .catch(err => {
        throw err
      })
  },
  insertRecipe({ commit, state }, { recipeObject }) {
    return axios.post(`v1/createrecipe/`, recipeObject).then(response => {
      return response.data
    })
  },
  updateRecipe({ commit, state }, { recipeObject }) {
    return axios
      .post(`v1/createrecipe/updateRecipe`, recipeObject)
      .then(response => {
        return response.data
      })
  },
  copyRecipe({ commit, state }, { params }) {
    return axios.post(`v1/createrecipe/copyRecipe`, params).then(response => {
      return response.data
    })
  },
  insertInvRecipe({ commit, state }, { recipeObject }) {
    return axios
      .post(`v1/createrecipe/invRecipe`, recipeObject)
      .then(response => {
        return response.data
      })
  },
  copyInvRecipe({ commit, state }, { params }) {
    return axios
      .post(`v1/createrecipe/copyInvRecipe`, params)
      .then(response => {
        return response.data
      })
  },
  getRecipeList({ commit, state }, { params }) {
    return axios
      .get(`/v1/createrecipe/`, {
        params: params,
      })
      .then(response => {
        const recipeList = response.data
        if (recipeList.length > 0) {
          return recipeList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getInvRecipeList({ commit, state }, { params }) {
    return axios
      .get(`/v1/createrecipe/invRecipe`, {
        params: params,
      })
      .then(response => {
        const recipeList = response.data
        if (recipeList.length > 0) {
          return recipeList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getTaxList({ commit, state }, { params }) {
    return axios
      .get(`/v1/tax/`, {
        params: params,
      })
      .then(response => {
        const taxList = response.data.docs
        if (taxList.length > 0) {
          return taxList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getLogList({ commit, state }, { params }) {
    return axios
      .get(`/v1/log/`, {
        params: params,
      })
      .then(response => {
        const logList = response.data
        if (logList.length > 0) {
          return logList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertLog({ commit, state }, { logObject }) {
    return axios.post(`v1/log/`, logObject).then(response => {
      return response.data
    })
  },
  getIssueNoteList({ commit, state }, { params }) {
    return axios
      .get(`/v1/issuenote/`, {
        params: params,
      })
      .then(response => {
        const issueNoteList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (issueNoteList.length > 0) {
          return issueNoteList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertIssueNote({ commit, state }, { issueNoteObject }) {
    return axios.post(`v1/issuenote/`, issueNoteObject).then(response => {
      return response.data
    })
  },
  insertNewIssueNote({ commit, state }, { issueNoteObject }) {
    return axios
      .post(`v1/issuenote/insertIN`, issueNoteObject)
      .then(response => {
        return response.data
      })
  },
  updateIssueNote({ commit, state }, { issueNoteObject }) {
    return axios
      .post(`v1/issuenote/updateIN`, issueNoteObject)
      .then(response => {
        return response.data
      })
  },
  approveIssueNote({ commit, state }, { issueNoteObject }) {
    return axios
      .post(`v1/issuenote/approveIN`, issueNoteObject)
      .then(response => {
        return response.data
      })
  },
  getIssueNoteCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/issuenote/getIssueNoteCount/`, {
        params: params,
      })
      .then(response => {
        const issueNoteCount = response.data
        return issueNoteCount
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierReturnList({ commit, state }, { params }) {
    return axios
      .get(`/v1/supplierreturn/`, {
        params: params,
      })
      .then(response => {
        const supplierReturnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (supplierReturnList.length > 0) {
          return supplierReturnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertSupplierReturn({ commit, state }, { supplierReturnObject }) {
    return axios
      .post(`v1/supplierreturn/`, supplierReturnObject)
      .then(response => {
        return response.data
      })
  },
  insertNewSupplierReturn({ commit, state }, { supplierReturnObject }) {
    return axios
      .post(`v1/supplierreturn/insertSR`, supplierReturnObject)
      .then(response => {
        return response.data
      })
  },
  updateNewSupplierReturn({ commit, state }, { supplierReturnObject }) {
    return axios
      .post(`v1/supplierreturn/updateSR`, supplierReturnObject)
      .then(response => {
        return response.data
      })
  },
  approveNewSupplierReturn({ commit, state }, { supplierReturnObject }) {
    return axios
      .post(`v1/supplierreturn/approveSR`, supplierReturnObject)
      .then(response => {
        return response.data
      })
  },
  getSupplierReturnCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/supplierreturn/getSupplierReturnCount/`, {
        params: params,
      })
      .then(response => {
        const supplierReturnCount = response.data
        return supplierReturnCount
      })
      .catch(err => {
        throw err
      })
  },
  getAllSRList({ commit, state }, { params }) {
    return axios
      .get(`/v1/supplierreturn/getAllSRList/`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        return grnList
      })
      .catch(err => {
        throw err
      })
  },
  insertStock({ commit, state }, { stockObject }) {
    return axios.post(`v1/stock/insertStock`, stockObject).then(response => {
      return response.data
    })
  },
  getStockList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stock/`, {
        params: params,
      })
      .then(response => {
        const stockList = response.data
        if (stockList.length > 0) {
          return stockList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllStockList({ commit, state }, { params }) {
    return axios
      .get(`/v1/stock/all`, {
        params: params,
      })
      .then(response => {
        const stockList = response.data
        if (stockList.length > 0) {
          return stockList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertCategory({ commit, state }, { categoryObject }) {
    return axios
      .post(`v1/category/`, categoryObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  copyCategory({ commit, state }, { params }) {
    return axios
      .post(`v1/category/copyCategory`, params)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  insertSubCategory({ commit, state }, { subCategoryObject }) {
    return axios
      .post(`v1/subcategory/`, subCategoryObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  copySubCategory({ commit, state }, { params }) {
    return axios
      .post(`v1/subcategory/copySubCategory`, params)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  insertSupplier({ commit, state }, { supplierObject }) {
    return axios
      .post(`v1/supplier/`, supplierObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  updateSupplier({ commit, state }, { supplierObject }) {
    return axios.put(`v1/supplier/`, supplierObject).then(response => {
      return response
    })
  },
  copySupplier({ commit, state }, { params }) {
    return axios
      .post(`v1/supplier/copySupplier`, params)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  insertTaxCombination({ commit, state }, { taxCombinationObject }) {
    return axios
      .post(`v1/taxcombination/`, taxCombinationObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  insertTax({ commit, state }, { taxObject }) {
    return axios
      .post(`v1/tax/`, taxObject)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  updateTax({ commit, state }, { taxObject }) {
    return axios.put(`v1/tax/`, taxObject).then(response => {
      return response
    })
  },
  updateTaxCombination({ commit, state }, { taxCombinationObject }) {
    return axios
      .put(`v1/taxcombination/`, taxCombinationObject)
      .then(response => {
        return response
      })
  },
  insertBatchPRocess({ commit, state }, { bpObject }) {
    return axios.post(`v1/batchprocess/`, bpObject).then(response => {
      return response.data
    })
  },
  runBatchProcess({ commit, state }, { bpObject }) {
    return axios
      .post(`v1/batchprocess/runBatchProcess`, bpObject)
      .then(response => {
        return response.data
      })
  },
  getBatchProcess({ commit, state }, { params }) {
    return axios
      .get(`/v1/batchprocess/`, {
        params: params,
      })
      .then(response => {
        const batchProcess = response.data.docs
        if (batchProcess.length > 0) {
          return batchProcess
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getTransferOutList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferout/`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getApprovedTransferOutList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferout/getApprovedTransferOut`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllTransferOutList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferout/all`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertTransferOut({ commit, state }, { trnasferOutObject }) {
    return axios.post(`v1/transferout/`, trnasferOutObject).then(response => {
      return response.data
    })
  },
  insertNewTransferOut({ commit, state }, { trnasferOutObject }) {
    return axios
      .post(`v1/transferout/insertTO`, trnasferOutObject)
      .then(response => {
        return response.data
      })
  },
  updateNewTransferOut({ commit, state }, { trnasferOutObject }) {
    return axios
      .post(`v1/transferout/updateTO`, trnasferOutObject)
      .then(response => {
        return response.data
      })
  },
  approveNewTransferOut({ commit, state }, { trnasferOutObject }) {
    return axios
      .post(`v1/transferout/approveTO`, trnasferOutObject)
      .then(response => {
        return response.data
      })
  },
  getTransferInList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferin/`, {
        params: params,
      })
      .then(response => {
        const trnasferInList = response.data
        if (trnasferInList.length > 0) {
          return trnasferInList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllTransferInList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferin/all`, {
        params: params,
      })
      .then(response => {
        const trnasferInList = response.data
        if (trnasferInList.length > 0) {
          return trnasferInList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertTransferIn({ commit, state }, { trnasferInObject }) {
    return axios.post(`v1/transferin/`, trnasferInObject).then(response => {
      return response.data
    })
  },
  insertNewTransferIn({ commit, state }, { trnasferInObject }) {
    return axios
      .post(`v1/transferin/insertTI`, trnasferInObject)
      .then(response => {
        return response.data
      })
  },
  updateNewTransferIn({ commit, state }, { trnasferInObject }) {
    return axios
      .post(`v1/transferin/updateTI`, trnasferInObject)
      .then(response => {
        return response.data
      })
  },
  approveNewTransferIn({ commit, state }, { trnasferInObject }) {
    return axios
      .post(`v1/transferin/approveTI`, trnasferInObject)
      .then(response => {
        return response.data
      })
  },
  getTransferInCount({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferin/getTransferInCount/`, {
        params: params,
      })
      .then(response => {
        const transferInCount = response.data
        return transferInCount
      })
      .catch(err => {
        throw err
      })
  },
  getOutletTransferInList({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferin/getAllTransferInList`, {
        params: params,
      })
      .then(response => {
        const trnasferInList = response.data
        if (trnasferInList.length > 0) {
          return trnasferInList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getNotificationLogList({ commit, state }, { params }) {
    return axios
      .get(`/v1/notification/`, {
        params: params,
      })
      .then(response => {
        const notificationList = response.data
        if (notificationList.length > 0) {
          return notificationList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  updateNotification({ commit, state }, { notificationObject }) {
    return axios
      .post(`v1/notification/update`, notificationObject)
      .then(response => {
        return response.data
      })
  },
  getTransactionDoc({ commit, state }, { params }) {
    return axios
      .get(`/v1/notification/transactionObj`, {
        params: params,
      })
      .then(response => {
        const transactionList = response.data
        if (transactionList.length > 0) {
          return transactionList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getPoListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/po/getPoListDocs`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList.length > 0) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getTransferOutListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferout/getTransferOutList`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList.length > 0) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllTransferOutListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferout/geAlltTransferOutList`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList.length > 0) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getTransferInListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/transferin/getTransferInListDocs`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList.length > 0) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },

  getByUid({ commit, state }, { params }) {
    return axios
      .get(`/v1/po/getByUid`, {
        params: params,
      })
      .then(response => {
        const poList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (poList != undefined) {
          return poList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getGrnListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/getGrnListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getGRNById({ commit, state }, { params }) {
    return axios
      .get(`/v1/grn/getGRNById`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList != undefined) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getINListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/issuenote/getINListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getNoteById({ commit, state }, { params }) {
    return axios
      .get(`/v1/issuenote/getNoteById`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList != undefined) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  insertNewSrn({ commit, state }, { srnObject }) {
    return axios.post(`v1/srn/insertSRN`, srnObject).then(response => {
      return response.data
    })
  },
  getAllSrn({ commit, state }, { params }) {
    return axios
      .get(`/v1/srn/`, {
        params: params,
      })
      .then(response => {
        const srnList = response.data
        if (srnList.length > 0) {
          return srnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  approveNewSRN({ commit, state }, { srnObject }) {
    return axios.post(`v1/srn/approveSRN`, srnObject).then(response => {
      return response.data
    })
  },
  updateNewSRN({ commit, state }, { srnObject }) {
    return axios.post(`v1/srn/updateSRN`, srnObject).then(response => {
      return response.data
    })
  },

  getallSRN({ commit, state }, { params }) {
    return axios
      .get(`/v1/srn/all`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getSrnListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/srn/getsrnList`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getAllSrnListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/srn/geAllsrnList`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getInvReport({ commit, state }, { params }) {
    return axios
      .get(`/v1/invReport/`, {
        params: params,
      })
      .then(response => {
        const invReports = response.data
        if (invReports.length > 0) {
          return invReports
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getSAListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockadjustment/getSAListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getSEListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/stockentry/getSEListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getWSListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/wastagemanagement/getWSListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getSRListDocs({ commit, state }, { params }) {
    return axios
      .get(`/v1/supplierreturn/getSRListDocs`, {
        params: params,
      })
      .then(response => {
        const grnList = response.data
        // commit('SET_POLIST_BOOKMARK', response.data.bookmark)
        if (grnList.length > 0) {
          return grnList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
  getApprovedSRNList({ commit, state }, { params }) {
    return axios
      .get(`/v1/srn/getApprovedSRN`, {
        params: params,
      })
      .then(response => {
        const trnasferOutList = response.data
        if (trnasferOutList.length > 0) {
          return trnasferOutList
        } else {
          return 'No List'
        }
      })
      .catch(err => {
        throw err
      })
  },
}
